import fetch from '@/api/fetch';

// 获取店铺列表接口-切店页面使用（企业员工的thor）
export function getShopList() {
  return fetch({
    url: '/baccount/workbench/vendor/list',
    method: 'get',
  });
}

// 切换店铺接口-风险检查以及生成token（企业员工的thor）
export function changeShop(params) {
  return fetch({
    url: '/baccount/workbench/switch/shop',
    method: 'post',
    data: params,
  });
}

// 切换店铺-保存会话接口（店铺pin的thor）
export function sessionSave(params) {
  return fetch({
    url: '/baccount/workbench/session/save',
    method: 'post',
    data: params,
  });
}

// 免登接口-下发登录态 - 用户组下发登录态接口
export function nplogin(params) {
  return fetch({
    fullUrl: process.env.VUE_APP_PASSPORT_DOMAIN,
    url: '/uc/nplogin',
    method: 'get',
    params,
  });
}
